<router-outlet
  *ngIf="(hideHeader$ | async) !== true"
  data-automation-id="header shell"
></router-outlet>
